module.exports = __webpack_public_path__ + "static/media/payPalLogo.49f7d7b8.png";